module.exports = __webpack_public_path__ + "assets/img/32e58322cea31832db4e7cfb4d36979d.svg";